<template>
  <div class="events-page">
    <div class="poster">
      <div class="wave-top"></div>

      <!-- Decorative elements - positioned intentionally -->

      <div class="sun"></div>

      <div class="wave-left">🌊</div>

      <div class="wave-right">🌊</div>

      <div class="fish-left">🐟</div>

      <div class="fish-right">🎣</div>

      <!-- QR Code positioned in upper right -->

      <div class="qr-section">
        <div class="qr-container">
          <img src="/img/qr-code.png" alt="RSVP QR Code" class="qr-code" />
        </div>

        <div class="qr-label">RSVP</div>

        <p>
          <a href="https://ibm.biz/mayolakehoa" target="_blank">
            https://ibm.biz/mayolakehoa
          </a>
        </p>
      </div>

      <div class="content">
        <div class="year-badge">6th Annual</div>

        <h1 class="title">Mayo Lake</h1>

        <div class="summer-text">SUMMER</div>

        <div class="party-text">Party</div>

        <div class="hosted-by">Hosted by Antpacks/Charlsons</div>

        <div class="address">3474 Mayo Lake Rd SW</div>

        <div class="date-time">
          <div class="date">Sunday, July 19th</div>

          <div class="time">4:00 - 7:00 pm</div>
        </div>

        <div class="details-container">
          <div class="details-box">
            <h3>Mayo Lake HOA Provides:</h3>

            <ul>
              <li>John Hardy's BBQ Pork</li>

              <li>John Hardy's BBQ Turkey</li>

              <li>Lemonade</li>

              <li>Water</li>

              <li>Mini Pops</li>
            </ul>
          </div>

          <div class="details-box">
            <h3>Please Bring:</h3>

            <ul>
              <li>Dish to pass</li>

              <li>(Label with common food allergens, vegan, etc)</li>

              <li>BYO additional beverages</li>
            </ul>
          </div>
        </div>

        <div class="special-note">
          <p>
            <span class="emoji-decoration">🎣</span>

            <span class="fishing-highlight">Fishing Competition</span>

            <span class="emoji-decoration">🎣</span>
          </p>

          <p style="font-size: 16px; margin-top: 8px">
            Bring your fishing poles for the contest!
            <br />
            Competition runs from 6:00 - 7:00 pm
          </p>
        </div>
      </div>

      <div class="wave-bottom"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Events',
  data() {
    return {}
  },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Pacifico&family=Fredoka:wght@400;600;700&family=Caveat:wght@700&display=swap');

.events-page {
  font-family: 'Fredoka', sans-serif;
  background: linear-gradient(135deg, #e0f4ff 0%, #b8e6ff 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 20px;
}

.poster {
  width: 8.5in;
  max-width: 100%;
  background: linear-gradient(
    180deg,
    #e6f7ff 0%,
    #ffffff 30%,
    #ffffff 70%,
    #fff9e6 100%
  );
  padding: 40px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: hidden;
}

/* Decorative elements */
.wave-top {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 80px;
  background: linear-gradient(
    90deg,
    #4a90e2 0%,
    #5dade2 25%,
    #87ceeb 50%,
    #6bb6ff 75%,
    #4a90e2 100%
  );
  clip-path: polygon(
    0 0,
    100% 0,
    100% 60%,
    90% 70%,
    80% 60%,
    70% 70%,
    60% 60%,
    50% 70%,
    40% 60%,
    30% 70%,
    20% 60%,
    10% 70%,
    0 60%
  );
}

.wave-bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 60px;
  background: linear-gradient(
    90deg,
    #5dade2 0%,
    #87ceeb 25%,
    #6bb6ff 50%,
    #4a90e2 75%,
    #5dade2 100%
  );
  clip-path: polygon(
    0 40%,
    10% 30%,
    20% 40%,
    30% 30%,
    40% 40%,
    50% 30%,
    60% 40%,
    70% 30%,
    80% 40%,
    90% 30%,
    100% 40%,
    100% 100%,
    0 100%
  );
}

/* Sun decoration */
.sun {
  position: absolute;
  top: 110px;
  left: 80px;
  width: 90px;
  height: 90px;
  background: radial-gradient(circle, #ffd700 0%, #ffa500 100%);
  border-radius: 50%;
  box-shadow: 0 0 40px rgba(255, 215, 0, 0.6);
  animation: pulse 3s ease-in-out infinite;
}

.sun::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 130px;
  height: 130px;
  background: radial-gradient(
    circle,
    transparent 40%,
    rgba(255, 215, 0, 0.3) 41%,
    transparent 42%
  );
  border-radius: 50%;
}

@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.08);
  }
}

/* Wave decorations - positioned symmetrically */
.wave-left {
  position: absolute;
  top: 320px;
  left: 30px;
  font-size: 55px;
  filter: drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.15));
  animation: wave-motion 2s ease-in-out infinite;
}

.wave-right {
  position: absolute;
  top: 420px;
  right: 30px;
  font-size: 55px;
  filter: drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.15));
  animation: wave-motion 2s ease-in-out infinite 1s;
}

@keyframes wave-motion {
  0%,
  100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-8px);
  }
}

/* Fish decorations for fishing theme */
.fish-left {
  position: absolute;
  bottom: 100px;
  left: 40px;
  font-size: 45px;
  filter: drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.15));
  animation: swim 4s ease-in-out infinite;
}

.fish-right {
  position: absolute;
  bottom: 130px;
  right: 50px;
  font-size: 40px;
  filter: drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.15));
  animation: swim 4s ease-in-out infinite 2s;
}

@keyframes swim {
  0%,
  100% {
    transform: translateX(0px);
  }
  50% {
    transform: translateX(10px);
  }
}

.content {
  position: relative;
  z-index: 1;
  text-align: center;
}

.year-badge {
  display: inline-block;
  background: linear-gradient(135deg, #4a90e2 0%, #5dade2 100%);
  color: white;
  padding: 8px 20px;
  border-radius: 25px;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 15px;
  box-shadow: 0 4px 15px rgba(74, 144, 226, 0.4);
}

.title {
  font-family: 'Caveat', cursive;
  font-size: 58px;
  color: #2e86c1;
  margin-bottom: 10px;
  line-height: 1.1;
  text-shadow: 2px 2px 0px rgba(46, 134, 193, 0.2);
}

.summer-text {
  font-family: 'Fredoka', sans-serif;
  font-size: 72px;
  font-weight: 700;
  margin: 20px 0;
  background: linear-gradient(
    135deg,
    #4a90e2 0%,
    #5dade2 25%,
    #ffd700 50%,
    #87ceeb 75%,
    #6bb6ff 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: 3px;
  position: relative;
}

.summer-text::before {
  content: '☀️';
  position: absolute;
  left: -60px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 50px;
  animation: rotate 4s linear infinite;
}

@keyframes rotate {
  from {
    transform: translateY(-50%) rotate(0deg);
  }
  to {
    transform: translateY(-50%) rotate(360deg);
  }
}

.summer-text::after {
  content: '🌊';
  position: absolute;
  right: -60px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 50px;
}

.party-text {
  font-family: 'Pacifico', cursive;
  font-size: 56px;
  color: #5dade2;
  margin-bottom: 25px;
  text-shadow: 2px 2px 0px rgba(93, 173, 226, 0.3);
}

.hosted-by {
  font-family: 'Caveat', cursive;
  font-size: 36px;
  color: #2e86c1;
  margin-bottom: 5px;
}

.address {
  font-family: 'Fredoka', sans-serif;
  font-size: 24px;
  color: #4a90e2;
  margin-bottom: 30px;
  font-weight: 600;
}

.date-time {
  background: linear-gradient(135deg, #87ceeb 0%, #6bb6ff 100%);
  padding: 20px;
  border-radius: 20px;
  margin: 30px 0;
  box-shadow: 0 4px 15px rgba(107, 182, 255, 0.4);
  border: 3px solid #4a90e2;
}

.date {
  font-size: 32px;
  font-weight: 700;
  color: #ffffff;
  text-transform: uppercase;
  letter-spacing: 2px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
}

.time {
  font-size: 36px;
  font-weight: 700;
  color: #ffffff;
  margin-top: 5px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
}

.details-container {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  margin-top: 30px;
}

.details-box {
  flex: 1;
  background: linear-gradient(135deg, #e6f7ff 0%, #ffffff 100%);
  padding: 20px;
  border-radius: 15px;
  border: 3px solid #5dade2;
  text-align: left;
}

.details-box h3 {
  font-family: 'Caveat', cursive;
  font-size: 28px;
  color: #2e86c1;
  margin-bottom: 12px;
  text-align: center;
}

.details-box ul {
  list-style: none;
  padding: 0;
}

.details-box li {
  font-size: 16px;
  color: #333;
  margin-bottom: 8px;
  padding-left: 20px;
  position: relative;
}

.details-box li::before {
  content: '☀️';
  position: absolute;
  left: 0;
  font-size: 14px;
}

.special-note {
  background: linear-gradient(135deg, #e6f7ff 0%, #fff9e6 100%);
  padding: 15px;
  border-radius: 15px;
  margin-top: 20px;
  border: 3px solid #4a90e2;
}

.special-note p {
  font-size: 18px;
  color: #2e86c1;
  font-weight: 600;
  margin: 5px 0;
}

.fishing-highlight {
  display: inline-block;
  background: linear-gradient(135deg, #ffd700 0%, #ffa500 100%);
  padding: 3px 10px;
  border-radius: 8px;
  font-weight: 700;
  color: #1a1a1a;
  box-shadow: 0 2px 8px rgba(255, 215, 0, 0.4);
}

.emoji-decoration {
  font-size: 30px;
  margin: 0 5px;
}

.qr-section {
  position: absolute;
  top: 140px;
  right: 60px;
  text-align: center;
  z-index: 10;
}

.qr-container {
  display: inline-block;
  padding: 10px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
  border: 2px solid #4a90e2;
}

.qr-code {
  width: 120px;
  height: 120px;
  display: block;
}

.qr-label {
  font-family: 'Fredoka', sans-serif;
  font-size: 14px;
  color: #2e86c1;
  margin-top: 8px;
  font-weight: 700;
}

.qr-section p {
  font-size: 12px;
  margin-top: 5px;
}

.qr-section a {
  color: #2e86c1;
  text-decoration: none;
}

.qr-section a:hover {
  text-decoration: underline;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .poster {
    padding: 20px;
  }

  .title {
    font-size: 42px;
  }

  .summer-text {
    font-size: 48px;
  }

  .party-text {
    font-size: 38px;
  }

  .details-container {
    flex-direction: column;
  }

  .qr-section {
    position: static;
    margin: 20px auto;
  }

  .sun {
    left: 20px;
    top: 90px;
    width: 60px;
    height: 60px;
  }

  .wave-left,
  .wave-right {
    font-size: 35px;
  }
}

@media print {
  .events-page {
    background: white;
    padding: 0;
  }
  .poster {
    box-shadow: none;
    margin: 0;
  }
}
</style>

